import CustomerIconOutlined from 'components/icons/CustomerIconOutlined';
import { FeatureGuide } from '../types';
import { howItHelps, tips, whatItIs } from './sections';

export const customerGuide: FeatureGuide = {
    key: 'customer',
    title: 'Customer',
    icon: <CustomerIconOutlined />,
    sections: [
        whatItIs('The customer this declaration is filed for, and the trader details it is submitted with.'),
        howItHelps(
            'Picking the right customer pre-fills the saved trader details, which cuts manual entry and avoids rejections caused by mismatched data.'
        ),
        tips([
            'Check the EORI shown next to the customer name before continuing.',
            'Keep customer records up to date - stale addresses are a common rejection reason.',
        ]),
    ],
};
